import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import {
  IconButton,
  IconButtonProps,
} from 'app/shared/components/molecules/IconButton';
import { ReactComponent as Close } from 'icons/close.svg';

export interface ModalCloseButtonProps extends Omit<IconButtonProps, 'size'> {
  disableClose?: boolean;
  iconSize?: IconButtonProps['size'];
  'data-qaid'?: string;
}

export const ModalCloseButton = ({
  disableClose = false,
  onClick,
  strokeColor,
  iconSize = 'md',
  position = 'relative',
  ariaLabel = 'close modal',
  'data-qaid': qaId = 'close-modal-button',
  ...props
}: ModalCloseButtonProps) => {
  const { colors } = useCurrentTheme();

  if (disableClose) {
    return null;
  }

  return (
    <>
      <IconButton
        data-qaid={qaId}
        aria-label={ariaLabel}
        icon={Close}
        onClick={onClick}
        backgroundColor="unset"
        strokeColor={strokeColor || colors.accent.primaryAccent.base}
        fillColor="none"
        size={iconSize}
        position={position}
        top="0"
        right="0"
        ml="auto"
        float="right"
        {...props}
      />
    </>
  );
};
